// extracted by mini-css-extract-plugin
export default {"usingTechText":"HomePageCardCards_usingTechText__f76ee","Hr":"HomePageCardCards_Hr__zAQeR"};